import './select-phone.less';
import React from 'react';
import {Button, Icon, Input} from 'antd';

export class SelectPhone extends React.Component {
  render() {
    const { phones } = this.props;

    if (!phones.length) {
      phones.push('');
    }

    return (
      <div className="select-phone">
        {phones.map((phone, index) => (
          <div className="phone-item" key={'phone-' + index}>
            <Input
              addonAfter={<Icon type="minus" onClick={() => index !== 0 && this.onRemove(index)} />}
              value={phones[index]}
              onChange={(e) => this.onChangePhone(index, e.target.value)}
            />
          </div>
        ))}
        <Button icon="plus" type="primary" style={{ marginTop: 12 }} onClick={() => this.onAdd()}>Добавить номер</Button>
      </div>
    );
  }

  onChangePhone(index, value) {
    const phones = [...this.props.phones];
    phones[index] = value;
    this.props.onChange(phones);
  }

  onAdd() {
    this.props.onChange([...this.props.phones, '']);
  }

  onRemove(index) {
    const phones = [...this.props.phones];
    phones.splice(index, 1);

    this.props.onChange(phones);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/select-phones.js